/* eslint-disable no-undef */
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../root-store-context";
import * as React from "react";
import { Collapse, CollapseProps } from "antd";
import { RecipientItem } from "./Recipient/RecipientItem";
import styles from "./Recipient/RecipientItem.module.scss";
import { MailJobFile } from "../../../../stores/AppStore/ApplicationStore";
import { useEffect, useState } from "react";

interface GroupedData<T> {
  [key: string]: T[];
}

export const Recipients = observer(() => {
  const { applicationStore } = useStore();
  const [items, setItems] = useState<CollapseProps["items"]>([]);

  type NestedKeyOf<T> = keyof T extends object
    ? { [K in keyof T]: NestedKeyOf<T[K]> }
    : string;

  function groupByNestedField<T>(
    list: T[],
    nestedField: NestedKeyOf<T>
  ): GroupedData<T> {
    const getNestedValue = (obj: any, keys: string[]) =>
      keys.reduce((acc, key) => (acc ? acc[key] : undefined), obj);

    return list.reduce((grouped: GroupedData<T>, item: T) => {
      const nestedKeys = nestedField.toString().split(".") as string[];
      const value = getNestedValue(item, nestedKeys);
      const key = String(value);
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
      return grouped;
    }, {});
  }

  useEffect(() => {
    const files = applicationStore.mailJob.files || [];
    const grouped = groupByNestedField<MailJobFile>(
      files,
      "fileInfo.communityKey" as any
    );

    const newItems: CollapseProps["items"] = [];

    Object.entries(grouped).forEach(([key, value]) => {
      newItems.push({
        key,
        label: (
          <div className={styles.recipientHeader}>
            {applicationStore.communities.find(
              (c) => c.id === value[0].fileInfo.communityKey
            )?.titleInDropdown}
          </div>
        ),
        children: <RecipientItem recipientItems={value} />,
      });
    });

    applicationStore.mailJob.files?.forEach((_) => {
      if (_.fileInfo.account) {
        if (
          _.fileInfo.recipient?.residentKey !==
          parseInt(_.fileInfo.account.toString(), 10)
        ) {
          applicationStore.getRecipientAsync(
            _,
            applicationStore.mailJob.communicationTypeId
          );
        }
      }
    });

    setItems(newItems);
  }, [applicationStore.mailJob.files]);

  return <Collapse items={items} defaultActiveKey={["1"]} />;
});
